import api from './api';

export const userService = {
  getAll: () => api.get('/users/'),
  getById: (id) => api.get(`/users/${id}`),
  create: (userData) => api.post('/users/', userData),
  update: (id, userData) => api.put(`/users/${id}`, userData),
  delete: (id) => api.delete(`/users/${id}`),
  changePassword: (id, currentPassword, newPassword) => api.post(`/users/change-password/${id}`, {
    current_password: currentPassword,
    new_password: newPassword
  }),
};
